namespace advisorop.components.servicer {

    export class CustodianAdvisoryFirmListController {
        custodians: domains.ICustodianAdvisoryFirm[];        
        dg: DevExpress.ui.dxDataGridOptions;
        onEditCustodian: any;
        
        constructor(private servicerService: services.ServicerService) {


            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Custodians"
                },
                bindingOptions: {
                    dataSource: "vm.custodians"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,                
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },                
                columns: [
                    { dataField: "custodian.name", caption: "Custodian" },                    
                    { dataField: "custodian.hasOfficeRanges", caption: "Use Office Range / Master Accts?" },
                    { dataField: "custodianFirmId", caption: "Custodian Firm Id" },
                    { dataField: "aumBasedFeeRate", caption: "AUM-Based Fee %", format: { type: "percent", precision: 4 } },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions" },
                    { dataField: "custodian.ordNo", caption: "Ord. no.", sortOrder: "asc", visible: false }
                    
                ]                
            };
        }  

        editCustodian(custodianAdvisoryFirmLink: domains.ICustodianAdvisoryFirm) {

            //console.log("Custodian advisry firm");
            //console.log(custodianAdvisoryFirmLink);

            this.onEditCustodian({ custodianAdvisoryFirmLink: custodianAdvisoryFirmLink });            
        };

        cancel(): void {            
        };
        
        $onInit(): void {          
        }

        $onChanges(changes): void {
            for (var prop in changes) {                
            }
        }
        
    }
    
    class CustodianAdvisoryFirmList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                custodians: "<",
                onEditCustodian: "&"
            };
            this.controller = ["servicerService", CustodianAdvisoryFirmListController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/custodian-advisory-firm-list.html";
        }
    }
    angular.module(Constants.APP).component("custodianAdvisoryFirmList", new CustodianAdvisoryFirmList());

}